"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgOnOff(props) {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M14.942 9C9.714 11.025 6 16.084 6 22.022 6 29.739 12.267 36 20 36c7.731 0 14-6.26 14-13.978C34 16.084 30.286 11.026 25.058 9M20 19V4", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0) }), void 0));
}
exports.default = SvgOnOff;
//# sourceMappingURL=OnOff.js.map